import { Status } from '@chakra-ui/react';
import { useSpel } from '@/spel';

/**
 * Een kleine melding bovenin zolang de verbinding met het spel weg is. Het scherm blijft de
 * laatst bekende staat tonen; Meteor deed dat ook, maar zonder het te laten zien.
 */
export function Verbindingsmelding() {
  const { status, staat } = useSpel();
  if (status !== 'verbroken' || !staat) return null;

  return (
    <Status.Root
      role="status"
      colorPalette="orange"
      position="fixed"
      top="2"
      left="50%"
      transform="translateX(-50%)"
      zIndex="toast"
      bg="white"
      px="4"
      py="2"
      borderRadius="full"
      boxShadow="md"
      fontSize="md"
    >
      <Status.Indicator />
      Verbinding met het spel verbroken, opnieuw verbinden...
    </Status.Root>
  );
}
